import { EventModel, EventOptionGroup, EventParticipant } from '@frontend/sports/betting-offer/feature/model';

export interface LiveAlertMessage {
    eventId: string;
    sportId: number;
    team: string;
    event: string;
    order: number;
    messageType?: LiveAlertMessageType[];
    team1Score?: number;
    team2Score?: number;
    text: string;
}

export class ShowcaseConstants {
    static TIMEDELAY = 4000;
    static ANIMATIONTIME = 1100;
}

export class LiveAlertMessageType {
    message: string;
    isHighlighted: boolean;
}

export class ShowcaseEventModel {
    active?: boolean;
    event: EventModel;
    gridGroup?: { [key: string]: string };
}

export interface ShowcaseModuleSitecoreItem {
    title: string;
    showOnHomeLobby: boolean;
    showOnSportsLobby: boolean;
    showOnCompetitionLobby: boolean;
    fixtureGroup: ShowcaseFixtureGroup[];
    showSpecialContents: boolean;
    contentSourceId: number;
}

export interface ShowcaseFixtureGroup {
    fixtureId?: string;
    sportId: number;
    competitionId: number;
    gridGroup: { [key: string]: string };
    regionId: number;
}

export enum Lobby {
    Home = 'Home',
    Sports = 'Sports',
    Competition = 'Competition',
}

export enum ViewType {
    SixPack,
    Default,
}

export interface ShowcaseModuleData {
    title: string;
    events: ShowcaseEventModel[];
    showSpecialContents: boolean;
}

export interface OptionGroupDetail {
    name?: string;
    optionGroup: EventOptionGroup | undefined;
    optionNames: string[];
}

export interface IShowcaseRequest {
    fixturesGroup: ShowcaseFixtureGroup[];
    requestId: number;
}

export interface IShowcaseRequestInfo {
    request: IShowcaseRequest[];
    sitecoreData: ShowcaseModuleSitecoreItem[];
}

export interface LobbySpecificRequest {
    lobby: Lobby;
    sportId?: number;
    competitionId?: number | number[];
    regionId?: number;
}

export enum FootballMessageIds {
    Goal = 255,
    RedCard = 254,
    Penalty = 249,
    PenaltyScored = 244,
    PenaltyMissed = 243,
    Corner = 252,
    Custom = 9999,
}

export enum AmericanFootballMessageIds {
    TouchDown = 251,
    TwoPointConversion = 249,
    OnePointConversion = 248,
    Safety = 252,
    FieldGoal = 253,
    Quarter = 1,
    Custom = 9999,
}

export enum BasketballMessageIds {
    Messages = 1,
}

export enum BaseballMessageIds {
    TotalRuns = 255,
    OneHomeRun = 254,
    TwoHomeRuns = 252,
    ThreeHomeRuns = 251,
    FourHomeRuns = 250,
    Messages = 1,
    Custom = 9999,
}

export enum IceHockeyMessageIds {
    Goal = 255,
    Messages = 1,
    PenaltyScored = 245,
    PenaltyMissed = 244,
    Custom = 9999,
}

export enum BasketBallPeriodIds {
    Notstarted = 0,
    Firstquarter = 1,
    FirstQuarterIntermission = 2,
    SecondQuarter = 3,
    SecondQuarterIntermission = 4,
    ThirdQuarter = 5,
    ThirdQuarterIntermission = 6,
    FourthQuarter = 7,
    FourthQuarterIntermission = 8,
    RegularTimeOver = 9,
    Overtime = 10,
    OvertimeIntermission = 11,
    End = 255,
}

export enum TouchDownInfo {
    TouchDownPointer = 6,
}

export enum CustomMessage {
    CustomMessageType = 9999,
}

export class LiveAlertEvent {
    participant1Score: number;
    participant2Score: number;
    currentlyServing?: number;
    period: { id?: number | undefined; name: string };
    eventId: string;
    sportId: number;
    team1Name: string;
    team2Name: string;
    time: string;
    constructor(
        participant1Score: number,
        participant2Score: number,
        eventId: string,
        sportId: number,
        participants: EventParticipant[],
        period: { id?: number | undefined; name: string },
        time?: string,
        currentlyServing?: number,
    ) {
        this.participant1Score = participant1Score;
        this.participant2Score = participant2Score;
        this.currentlyServing = currentlyServing;
        this.period = period;
        this.eventId = eventId;
        this.sportId = sportId;
        if (time) {
            this.time = time;
        }
        if (participants && participants.length === 2) {
            this.team1Name = participants[0].shortName || participants[0].name;
            this.team2Name = participants[1].shortName || participants[1].name;
        }
    }
}

export enum FeatureTab {
    Scoreboard = 1,
    Video = 2,
    Simulation = 3,
    Statistics = 4,
}
